/**
 * Parses a PanelContainer. It adds no fields beyond Control: the base Control
 * parser collects its `theme_override_styles/panel` StyleBox.
 */
import { parseControl } from '../control/parser';
export function parsePanelContainer(heading, properties) {
    return parseControl(heading, properties);
}
//# sourceMappingURL=parser.js.map